import $ from 'jquery';
import transitionend from './transitionend';
import pubsub from './pubsub.js';

// layout-header__main_search-mode
let $header = $('.layout-header');
let $mainHeader = $('.layout-header__main').eq(0);
let $mainHeaderNav = $mainHeader.find('.layout-header__main__nav').eq(0);
let $searchWrapper = $mainHeader.find('.layout-header__main__search__wrapper');
let $searchForm = $mainHeader.find('.layout-header__main__search__form');
let $searchInput = $searchForm.find('input');
let $searchButton = $mainHeader.find('.layout-header__main__search__button-search');
let $searchButtonClose = $mainHeader.find('.layout-header__main__search__button-close');
let $submenuWrapper = $('.layout-header__submenu-wrapper');
let $submenuItems = $('.layout-header__submenu');
let $menuItems = $('[data-submenu]');

const initSearch = function()
{
    $searchButton.on('click', function() {
        if(!$mainHeader.hasClass('layout-header__main_search-mode')) {

            $mainHeader.one(transitionend, function() {
                $searchInput.trigger('focus');
            })

            $searchWrapper.css('width', Math.ceil($mainHeader.width() - $mainHeaderNav.get(0).offsetLeft));
            $mainHeader.addClass('layout-header__main_search-mode');
        } else {
            $searchWrapper.removeAttr("style");
            $mainHeader.removeClass('layout-header__main_search-mode')
        }
    })

    $searchButtonClose.on('click', function() {
        $searchInput.val('');
    })
}

const initScroll = function() {

    let isFloat = false;

    pubsub.on('page.scroll', function(st) {
        if(st > 0) {
            if(!isFloat)
            {
                isFloat = true;
                $header.addClass('_float');
            }
        }
        else if(isFloat) {
            isFloat = false
            $header.removeClass('_float')
        }
    })
}

const initMenu = function()
{
    const closeSubmenus = function($submenus, cb) {
        $submenus.one('transitionend', function() {
            $(this).removeClass('_closing').removeClass('_open').removeClass('_flow');

            if(typeof(cb) === 'function') {
                cb();
            }
        });
        $submenus.addClass('_closing');
    };

    let isBusy = false;

    $(document).on('click', '.overlay', function() {
        let $activeSubmenu = $submenuWrapper.find(`.layout-header__submenu._open`);
        closeSubmenus($activeSubmenu);

        $submenuWrapper.removeClass('_open');
        $submenuWrapper.find('._active').removeClass('_active');

        $menuItems.removeClass('_active');
        $menuItems.siblings('._active').removeClass('_active');

        $.overlay.close();
    });

    $header.on('click', '[data-submenu]', function(e) {
        const toElement = e.toElement || e.target;

        if(toElement && toElement.tagName === 'A' && toElement.href.length > 2) {
            return true;
        }

        e.preventDefault();

        const submenuId = $(this).data('submenu');

        if(submenuId) {
            const $submenu = $submenuItems.filter(`[data-id="${submenuId}"]`)
            if($submenu.length) {
                const level = $submenu.data('level');

                if(isBusy) {
                    return;
                }

                // если уровень подменю и парент не найдены
                if(!(level || $submenuWrapper)) {
                    // завершаем
                    return;
                }

                setTimeout(function() {
                    isBusy = false;
                }, 300);

                // если текущее подменю уже открыто значит его тоглим в закрытие
                if($($submenu).hasClass('_open')) {
                    if(level === 1) {
                        $.overlay.close();
                    }

                    let $activeSubmenu = $submenuWrapper.find(`.layout-header__submenu._open${level > 1 ? `[data-level="${level}"]` : ''}`);

                    closeSubmenus($activeSubmenu);

                    // проверяем что закрытие идет подменю первого уровня
                    if(level === 1) {
                        $submenuWrapper.removeClass('_open');
                        $submenuWrapper.find('._active').removeClass('_active');
                    }

                    $(this).removeClass('_active');
                    $(this).siblings('._active').removeClass('_active');
                }
                // или же открываем
                else {
                    $.overlay.open();

                    let $activeSubmenu = $submenuWrapper.find(`.layout-header__submenu._open[data-level="${level}"]`).not($submenu);

                    // проверяем уровень и открыто ли общее меню
                    if(level == 1 && $submenuWrapper.hasClass('_open')) {
                        // если нажат был первый уровень, то может быть
                        // что были открыты меню второго уровня, нужно их найти и закрыть
                        closeSubmenus($submenuWrapper.find('.layout-header__submenu._open[data-level="2"]'));
                        // скидываем во всех подменю эктив классы
                        $submenuWrapper.find('._active').removeClass('_active');
                    }

                    if($activeSubmenu.length) {
                        if(level == 2) {
                            $activeSubmenu.addClass('_flow');
                        }
                        $submenu.addClass('_flow');
                    }
                    $submenu.addClass('_preopen');

                    window.setTimeout(function() {

                        closeSubmenus($activeSubmenu, function() {
                            $submenu.removeClass('_flow');
                        });

                        $submenuWrapper.addClass('_open');

                        $submenu.addClass('_open').removeClass('_preopen');
                    }, 50);

                    $(this).addClass('_active');
                    $(this).siblings('._active').removeClass('_active');
                }
            }
        }
    });
}

const initBurger = function() {
    let isBusy = false;

    const burgerActiveClass = '_active';
    const menuOpenClass = '_open';


    $('.js-menu-trigger').on('click', function(e) {
        let $this = $(this);
        let isActive = $this.hasClass(burgerActiveClass);

        e.preventDefault();

        if($(window).width() > 1023) {
            return false;
        }

        if(isBusy) {
            return;
        }
        isBusy = true;

        if(isActive) {
            $mainHeaderNav.one(transitionend, function() {
                $mainHeaderNav.css({'display': 'none'});
                isBusy = false;
            });

            document.body.style.position = 'static';
            $this.removeClass(burgerActiveClass)
            $mainHeaderNav.removeClass(menuOpenClass);
        }
        else {
            $mainHeaderNav
                .css({'display': 'block'})
                .one(transitionend, function() {
                    document.body.style.position = 'fixed';

                    isBusy = false;
                });

            setTimeout(function() {

                $this.addClass(burgerActiveClass)
                $mainHeaderNav.addClass(menuOpenClass);

            }, 150);
        }
    });
}


const init = function()
{
    initScroll();
    initSearch();
    initMenu();
    initBurger();
}

export default init;
